import { Theme } from '@ublend-npm/aulaui-core';

export const createStyles = (theme: Theme) => {
  return {
    scheduledPostListContainer: {
      display: 'flex',
      flexDirection: 'column',
      boxSizing: 'border-box',
      width: '100%',
      height: '100%',
      minWidth: 0,
      minHeight: 0,
    },
    scheduledPostListHeader: {
      display: 'flex',
      flexDirection: 'column',
      flexShrink: 0,
      boxSizing: 'border-box',
      width: '100%',
      maxWidth: { xs: '100%', md: 800 },
      mx: 'auto',
      px: { xs: '1rem', md: '1.5rem', lg: 0 },
      pt: { xs: '1rem', md: '1.5rem', lg: '40px' },
      pb: '10px',
      gap: { xs: '14px', md: 0 },
    },
    titleRow: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      minWidth: 0,
      gap: 1,
    },
    scheduledPostListScroll: {
      flex: 1,
      width: '100%',
      minWidth: 0,
      minHeight: 0,
      overflowX: 'hidden',
      overflowY: 'auto',
    },
    scheduledPostListContent: {
      display: 'flex',
      flexDirection: 'column',
      boxSizing: 'border-box',
      width: '100%',
      maxWidth: { xs: '100%', md: 800 },
      px: { xs: '1rem', md: '1.5rem', lg: 0 },
      pb: { xs: '1rem', md: '1.5rem' },
      mx: 'auto',
      minWidth: 0,
      gap: '1rem',
    },
    title: {
      minWidth: 0,
      fontSize: { xs: '1rem', md: '1.25rem' },
      fontWeight: 500,
      lineHeight: '160%',
      letterSpacing: '0.15px',
    },
    backButton: {
      display: { xs: 'inline-flex', md: 'none' },
      alignSelf: 'flex-start',
      minWidth: 'fit-content',
      ml: -1,
      px: 1,
      py: 0.5,
      gap: 0.5,
      border: 0,
      borderRadius: 0.5,
      color:
        theme.palette.mode === 'dark'
          ? theme.palette.primary.light
          : theme.palette.primary.dark,
      fontSize: '1rem',
      fontWeight: 500,
      '& .MuiButton-startIcon': {
        margin: 0,
      },
      '&:hover': {
        border: 0,
        backgroundColor: theme.palette.action.hover,
      },
      '&:focus-visible': {
        outline: `2px solid ${theme.palette.primary.main}`,
        outlineOffset: 2,
      },
    },
    closeButton: {
      display: { xs: 'none', md: 'inline-flex' },
    },
  };
};
